import i18next from "i18next";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { isValidArray, nextPageRoute } from "../../../utils/modules";

const JobSelection = () => {
  const navigate = useNavigate();
  const params = useParams();

  const [selectedJobs, setSelectedJobs] = useState([]);

  const toggleJobSelection = (job) => {
    if (selectedJobs.includes(job)) {
      setSelectedJobs(
        selectedJobs.filter((selectedJob) => selectedJob !== job)
      );
    } else {
      setSelectedJobs([...selectedJobs, job]);
    }
  };

  const isSelected = (job) => {
    return selectedJobs.includes(job)
      ? "job-selected-button"
      : "job-select-button";
  };

  return (
    <MobileViewLayout>
      <div className="flex-grow-1 d-flex flex-column align-content-center justify-content-start position-relative px-3">
        <div
          className="d-flex flex-column justify-content-center w-100 px-2 pb-3 age-selection-heading"
          style={{ paddingTop: "68px" }}
        >
          <h1 className="fs30 text-center fw-bolder age-selection-heading pt-0 m-0 pb-0 travel-heading jobs-heading">
            <Trans i18nKey={"job_interests.question"} />
          </h1>
          <div
            className="d-flex flex-column gap-3"
            style={{ paddingTop: "50px" }}
          >
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("Digital Marketing")}`}
                onClick={() => toggleJobSelection("Digital Marketing")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.digital_marketing"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("SMM")}`}
                onClick={() => toggleJobSelection("SMM")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.smm"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("Affiliate Marketing")}`}
                onClick={() => toggleJobSelection("Affiliate Marketing")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.affiliate_marketing"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Dropshipping")}`}
                onClick={() => toggleJobSelection("Dropshipping")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.dropshipping"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("Content Writing")}`}
                onClick={() => toggleJobSelection("Content Writing")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.content_writing"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Copywriting")}`}
                onClick={() => toggleJobSelection("Copywriting")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.copywriting"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("Translation")}`}
                onClick={() => toggleJobSelection("Translation")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.translation"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Graphic Design")}`}
                onClick={() => toggleJobSelection("Graphic Design")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.graphic_design"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("Blogging")}`}
                onClick={() => toggleJobSelection("Blogging")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.blogging"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Illustration")}`}
                onClick={() => toggleJobSelection("Illustration")}
              >
                <p
                  className={`text-center m-0 text-nowrap ${
                    i18next.language === "en" ? "fs18" : "fs-16"
                  }`}
                  style={{ fontWeight: 700 }}
                >
                  <Trans i18nKey={"job_interests.illustration"} />
                </p>
              </div>
            </div>

            <Button
              onClick={() =>
                isValidArray(selectedJobs) &&
                nextPageRoute(navigate, `/${params.gender}/readinessrating`)
              }
              className="bgSecondary fw-bold job-continue-button mx-0 w-100 sticky-button text-capitalize"
              style={{ height: "60px" }}
            >
              <Trans i18nKey={"common_text.continue"} />
            </Button>
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default JobSelection;
